import { APIClient } from "./api_helper";

import * as url from "./url_helper";

const api = new APIClient();

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

// //is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
export const postVendorRegister = (data : any) => api.create(url.POST_VENDOR_REGISTER, data);

// AFFILIATE Register Method
export const postAffiliateRegister = (data : any) => api.create(url.AFFILIATE_POST_VENDOR_REGISTER, data);
export const getAffiliateRegistrationCode = (data : any) => api.create(url.AFFILIATE_GET_CODE, data);
export const postAffiliateLogin = (data : any) => api.create(url.POST_AFFILIATE_LOGIN, data);

// Login Method
export const postVendorLogin = (data : any) => api.create(url.POST_VENDOR_LOGIN, data);
export const postVendorRefreshToken = (data: any) => api.create(url.POST_VENDOR_REFRESH_TOKEN, data);

export const getRegistrationCode = (data : any) => api.create(url.GET_CODE, data);


// postForgetPwd
export const postFakeForgetPwd = (data : any) => api.create(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
export const getUserProfile = () => api.get(url.GET_USER_PROFILE);
export const updateVendorProfile  = (data: any) => api.put(url.PUT_VENDOR_PROFILE, data);
export const changeVendorPassword = (data: any) => api.put(url.PUT_VENDOR_PASSWORD, data);
export const postJwtProfile = (data : any) => api.create(url.POST_EDIT_JWT_PROFILE, data);

export const postFakeProfile = (data : any) => api.update(url.POST_EDIT_PROFILE + '/' + data.idx, data);

// Register Method
export const postJwtRegister = (url : string, data  :any) => {
  return api.create(url, data)
    .catch(err => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message = "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method
export const postJwtLogin = (data : any) => api.create(url.POST_FAKE_JWT_LOGIN, data);

//VENDOR
export const getVendorStats = () => api.get(url.GET_VENDOR_STAT);
export const getVendorDashboard = () => api.get(url.GET_VENDOR_DASHBOARD);
// check whether vendor has an active property
export const getVendorActivePropertyStatus = () => api.get(url.GET_VENDOR_ACTIVE_STATUS);
export const getTopSellingProperties = () => api.get(url.GET_TOP_SELLING_PROPERTIES);
export const getVendorProperties = (params?: Record<string, any>) => api.get(url.GET_VENDOR_PROPERTIES, params);
export const getTopSellingRooms = () => api.get(url.GET_TOP_SELLING_ROOMS);
export const getVendorPropertiesTaxesFees = () => api.get(url.GET_VENDOR_PROPERTIES_TAXES_FEES);
export const getRoomTypes = () => api.get(url.GET_ROOM_TYPES);
export const getVendorPropertiesAmenities = () => api.get(url.GET_VENDOR_PROPERTIES_AMENITIES);
export const getRoomAmenities = () => api.get(url.GET_ROOMS_AMENITIES);
export const getVendorBookings = (params?: Record<string, any>) => api.get(url.GET_VENDOR_BOOKINGS, params);
export const getVendorPropertiesPolicies = (propertyId: number | string) =>
  api.get(url.GET_VENDOR_PROPERTIES_POLICIES(propertyId));
export const deleteVendorPropertyRoom = (propertyId: number | string, roomId: number | string) =>
  api.delete(url.DELETE_VENDOR_PROPERTY_ROOM(propertyId, roomId));
export const getVendorBooking = (id: number | string) => api.get(url.GET_VENDOR_BOOKING(id));
export const requestBookingCancel = (id: number | string, data: object) => api.create(url.POST_VENDOR_BOOKING_CANCEL(id), data);
export const requestBookingDateChange = (id: number | string, data: object) => api.create(url.POST_VENDOR_BOOKING_DATE_CHANGE(id), data);
export const confirmPayAtHotelPayment = (id: number | string, data: object) => api.create(url.POST_VENDOR_BOOKING_CONFIRM_PAY_AT_HOTEL(id), data);
export const getVendorPropertyServiceTypes = () => api.get(url.GET_VENDOR_PROPERTY_SERVICE_TYPES);
export const getVendorPropertyCompletionStatus = (propertyId: number | string) =>
  api.get(url.GET_VENDOR_PROPERTY_COMPLETION_STATUS(propertyId));
export const getVendorPropertyTodayActivity = (propertyId: number | string) =>
  api.get(url.GET_VENDOR_PROPERTY_TODAY_ACTIVITY(propertyId));
export const setRoomAvailability = (roomId: number | string, data: object) =>
  api.create(url.SET_ROOM_AVAILABILITY(roomId), data);
export const getRoomAvailability = (roomId: number | string) =>
  api.get(url.GET_ROOM_AVAILABILITY(roomId));
export const getPropertyRoomsAvailability = (
  propertyId: number | string,
  params: { start_date: string; end_date: string }
) => api.get(url.GET_PROPERTY_ROOMS_AVAILABILITY(propertyId), params);
export const getPropertyImages = (propertyId: number | string) =>
  api.get(url.GET_PROPERTY_IMAGES(propertyId));
export const putPropertyImage = ({ propertyId, imageId, imageData }: any) =>
  api.update(url.PUT_PROPERTY_IMAGE(propertyId, imageId), imageData);
export const deletePropertyImage = ({ propertyId, imageId }: any) =>
  api.delete(url.DELETE_PROPERTY_IMAGE(propertyId, imageId));
export const getPropertyAmenitiesDetail = (propertyId: number | string) =>
  api.get(url.GET_PROPERTY_AMENITIES_DETAIL(propertyId));
export const getPropertyRoomsList = (propertyId: number | string) =>
  api.get(url.GET_PROPERTY_ROOMS_LIST(propertyId));
export const getRoomAmenitiesDetail = (roomId: number | string) =>
  api.get(url.GET_ROOM_AMENITIES_DETAIL(roomId));
export const getVendorPropertyStats = (params?: any) => {
  const queryParams = new URLSearchParams();
  
  if (params) {
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.per_page) queryParams.append('per_page', params.per_page.toString());
    if (params.sort_by) queryParams.append('sort_by', params.sort_by);
    if (params.sort_order) queryParams.append('sort_order', params.sort_order);
    if (params.status) queryParams.append('status', params.status);
    if (params.search) queryParams.append('search', params.search);
  }
  
  const queryString = queryParams.toString();
  const endpoint = queryString 
    ? `${url.GET_VENDOR_PROPERTIES_STATS}?${queryString}` 
    : url.GET_VENDOR_PROPERTIES_STATS;
  
  return api.get(endpoint);
};
export const postVendorProperties = (data: any) => {
  // Check if data is FormData
  if (data instanceof FormData) {
    // For FormData, we need to use createFormData or similar method
    // that sets proper headers for multipart/form-data
    return api.createWithFormData(url.POST_VENDOR_PROPERTIES, data);
  } else {
    // For regular JSON data
    return api.create(url.POST_VENDOR_PROPERTIES, data);
  }
};
export const postVendorPropertiesPolicies = ({ policiesData, propertyId }: any) => {
  const endpoint = url.POST_VENDOR_PROPERTIES_POLICIES(propertyId);
  return api.create(endpoint, policiesData);
};
export const postVendorPropertyTaxesFees = ({ taxesFeesData, propertyId }: any) => {
  const endpoint = url.POST_VENDOR_PROPERTY_TAXES_FEES(propertyId);
  return api.create(endpoint, taxesFeesData);
};
export const postVendorPropertyServices = ({ servicesData, propertyId }: any) => {
  const endpoint = url.POST_VENDOR_PROPERTY_SERVICES(propertyId);
  return api.create(endpoint, servicesData);
};
export const postVendorPropertyRoom = ({ roomData, propertyId }: any) => {
  const endpoint = url.POST_VENDOR_PROPERTY_ROOMS(propertyId);
  return api.create(endpoint, roomData);
};
export const postVendorPropertiesAmenities = ({ amenitiesData, propertyId }: any) => {
  const endpoint = url.POST_VENDOR_PROPERTIES_AMENITIES(propertyId);
  return api.create(endpoint, amenitiesData);
};
export const postVendorPropertyImages = ({ imageData, propertyId }: any) => {
  const endpoint = url.POST_VENDOR_PROPERTY_UPLOAD_IMAGES(propertyId);
  return api.createWithFormData(endpoint, imageData);
};
export const postVendorPropertyRoomImages = ({ imageData, propertyId, roomId }: any) => {
  const endpoint = url.POST_VENDOR_PROPERTY_ROOM_UPLOAD_IMAGES(propertyId, roomId);
  return api.createWithFormData(endpoint, imageData);
};
export const postVendorRoomAmenities = ({ amenitiesData, roomId }: any) => {
  const endpoint = url.POST_VENDOR_ROOM_AMENITIES(roomId);
  return api.create(endpoint, amenitiesData);
};
// VENDOR UPDATE (PUT) methods
export const getVendorProperty = (propertyId: number | string) =>
  api.get(url.GET_VENDOR_PROPERTY(propertyId));
export const putVendorProperty = ({ propertyData, propertyId }: any) =>
  api.put(url.PUT_VENDOR_PROPERTY(propertyId), propertyData);
export const putVendorPropertiesPolicies = ({ policiesData, propertyId }: any) =>
  api.put(url.PUT_VENDOR_PROPERTIES_POLICIES(propertyId), policiesData);
export const putVendorPropertiesAmenities = ({ amenitiesData, propertyId }: any) =>
  api.put(url.PUT_VENDOR_PROPERTIES_AMENITIES(propertyId), amenitiesData);
export const putVendorPropertyServices = ({ servicesData, propertyId }: any) =>
  api.put(url.PUT_VENDOR_PROPERTY_SERVICES(propertyId), servicesData);
export const putVendorPropertyTaxesFees = ({ taxesFeesData, propertyId }: any) =>
  api.put(url.PUT_VENDOR_PROPERTY_TAXES_FEES(propertyId), taxesFeesData);
export const putVendorPropertyRoom = ({ roomData, propertyId, roomId }: any) =>
  api.put(url.PUT_VENDOR_PROPERTY_ROOM(propertyId, roomId), roomData);
export const putVendorRoomAmenities = ({ amenitiesData, roomId }: any) =>
  api.put(url.PUT_VENDOR_ROOM_AMENITIES(roomId), amenitiesData);
export const postVendorPropertyContract = ({ contractType, propertyId }: any) =>
  api.create(url.POST_VENDOR_PROPERTY_CONTRACT(propertyId), { contract_type: contractType });

// Dashboard Ecommerce
// Revenue
export const getAllRevenueData = () => api.get(url.GET_ALLREVENUE_DATA);
export const getMonthRevenueData = () => api.get(url.GET_MONTHREVENUE_DATA);
export const getHalfYearRevenueData = () => api.get(url.GET_HALFYEARREVENUE_DATA);
export const getYearRevenueData = () => api.get(url.GET_YEARREVENUE_DATA);

// Affiliate Dashboard
export const getAffiliateProfile  = () => api.get(url.GET_AFFILIATE_PROFILE);
export const putAffiliateProfile  = (data: any) => api.put(url.GET_AFFILIATE_PROFILE, data);
export const getAffiliateDashboard = () => api.get(url.GET_AFFILIATE_DASHBOARD);
export const getAffiliateAnalytics = () => api.get(url.GET_AFFILIATE_ANALYTICS);
export const getAffiliateReferrals = () => api.get(url.GET_AFFILIATE_REFERRALS);
export const getAffiliateCommissions = () => api.get(url.GET_AFFILIATE_COMMISSIONS);
export const getAffiliateMarketingMaterials = () => api.get(url.GET_AFFILIATE_MARKETING_MATERIALS);
export const postAffiliateGenerateLink = (data: any) => api.create(url.POST_AFFILIATE_GENERATE_LINK, data);




